import { configureStore } from '@reduxjs/toolkit';
import { widthsReducer } from '../resizing/redux/widthsSlice';
export const createWidthsStore = ({
  initialWidths
}) => configureStore({
  reducer: {
    widths: widthsReducer
  },
  devTools: {
    name: 'customer-data-table-widths'
  },
  preloadedState: {
    widths: {
      widths: initialWidths
    }
  }
});